// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false
/* eslint-disable no-new */

//引用vuex储存
import store from './store';
Vue.prototype.$store = store;

//引入elementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

//引入全部api接口，通过this.api_接口名调用
// import * as apis from "@/api/user";
// for(let i in apis) {
// 	Vue.prototype['api_'+i] = apis[i];
// }

// 页面权限控制
import '@/permission'

new Vue({
	el: '#app',
	router, //引用router页面跳转
	components: {
		App
	},
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js